export const FORMATTED_PHONE_NUMBER = "(831) 900-4723";
export const PHONE_LINK = "tel:+18319004723";
